import { makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import React from 'react';
import { ListTable } from '~/modules/common/components/ListTable';
import { ListTableThemeProvider } from '~/modules/common/components/ListTable/ListTableThemeContext';
import { useListColumns } from './columns';

const useListTableThemeProviderStyles = makeStyles(theme => ({
  tableRoot: {
    borderCollapse: 'collapse'
  },
  tableBody: {
    backgroundColor: 'inherit',
    borderWidth: theme.spacing(0.2, 0),
    borderColor: theme.palette.grey[400],
    borderStyle: 'solid'
  },
  tableHeader: {
    backgroundColor: 'inherit'
  },
  tableHeaderCell: {
    padding: theme.spacing(0, 2),
    verticalAlign: 'bottom',
    whiteSpace: 'normal',
    height: 0,
    color: theme.palette.grey[800],
    fontSize: theme.typography.caption.fontSize,
    position: 'static'
  },
  tableCell: {
    height: 0,
    padding: theme.spacing(0.5, 2),
    fontSize: theme.typography.caption.fontSize,
    '& span': {
      fontSize: theme.typography.caption.fontSize
    },
    '& p': {
      fontSize: theme.typography.caption.fontSize
    }
  }
}));

const useColumnStyles = makeStyles(theme => ({
  text: {
    '& p': {
      maxWidth: theme.spacing(15),
      whiteSpace: 'break-spaces'
    }
  }
}));

const useCardStyles = makeStyles(theme => ({
  card: {
    boxShadow: 'none',
    backgroundColor: 'inherit',
    padding: theme.spacing(1, 0)
  }
}));

export const ClientTaxRatesListTable = ({
  taxRatesLoading,
  taxRateRows,
  taxRateHeaders
}) => {
  const providerClasses = useListTableThemeProviderStyles();
  const cardClasses = useCardStyles();
  const columnClasses = useColumnStyles();
  const columns = useListColumns({
    classes: columnClasses,
    taxRateHeaders
  });

  return (
    <>
      {taxRateRows.length ? (
        <ListTableThemeProvider classes={providerClasses}>
          <ListTable
            variant="table"
            classes={cardClasses}
            columns={columns}
            records={taxRateRows}
            isLoading={taxRatesLoading}
          />
        </ListTableThemeProvider>
      ) : null}
    </>
  );
};

ClientTaxRatesListTable.propTypes = {
  taxRatesLoading: PropTypes.bool,
  taxRateRows: PropTypes.array,
  taxRateHeaders: PropTypes.array
};

export default ClientTaxRatesListTable;
